export const PARTIDOS = [
	{
		id: 1,
		description: '1° DE MAYO'
	},
	{
		id: 2,
		description: '12 DE OCTUBRE'
	},
	{
		id: 3,
		description: '2 DE ABRIL'
	},
	{
		id: 4,
		description: '25 DE MAYO'
	},
	{
		id: 5,
		description: '9 DE JULIO'
	},
	{
		id: 6,
		description: 'ADOLFO ALSINA'
	},
	{
		id: 7,
		description: 'ADOLFO GONZALES CHAVES'
	},
	{
		id: 8,
		description: 'AGUIRRE'
	},
	{
		id: 9,
		description: 'ALBARDÓN'
	},
	{
		id: 10,
		description: 'ALBERDI'
	},
	{
		id: 11,
		description: 'ALBERTI'
	},
	{
		id: 12,
		description: 'ALMIRANTE BROWN'
	},
	{
		id: 13,
		description: 'ALUMINÉ'
	},
	{
		id: 14,
		description: 'AMBATO'
	},
	{
		id: 15,
		description: 'ANCASTI'
	},
	{
		id: 16,
		description: 'ANDALGALÁ'
	},
	{
		id: 17,
		description: 'ANGACO'
	},
	{
		id: 18,
		description: 'ÁNGEL VICENTE PEÑALOZA'
	},
	{
		id: 19,
		description: 'ANTA'
	},
	{
		id: 20,
		description: 'ANTÁRTIDA ARGENTINA'
	},
	{
		id: 21,
		description: 'ANTOFAGASTA DE LA SIERRA'
	},
	{
		id: 22,
		description: 'AÑELO'
	},
	{
		id: 23,
		description: 'APÓSTOLES'
	},
	{
		id: 24,
		description: 'ARAUCO'
	},
	{
		id: 25,
		description: 'ARRECIFES'
	},
	{
		id: 26,
		description: 'ATAMISQUI'
	},
	{
		id: 27,
		description: 'ATREUCÓ'
	},
	{
		id: 28,
		description: 'AVELLANEDA'
	},
	{
		id: 29,
		description: 'AYACUCHO'
	},
	{
		id: 30,
		description: 'AZUL'
	},
	{
		id: 31,
		description: 'BAHÍA BLANCA'
	},
	{
		id: 32,
		description: 'BALCARCE'
	},
	{
		id: 33,
		description: 'BANDA'
	},
	{
		id: 34,
		description: 'BARADERO'
	},
	{
		id: 35,
		description: 'BARILOCHE'
	},
	{
		id: 36,
		description: 'BELÉN'
	},
	{
		id: 37,
		description: 'BELGRANO'
	},
	{
		id: 38,
		description: 'BELLA VISTA'
	},
	{
		id: 39,
		description: 'BENITO JUÁREZ'
	},
	{
		id: 40,
		description: 'BERAZATEGUI'
	},
	{
		id: 41,
		description: 'BERISSO'
	},
	{
		id: 42,
		description: 'BERMEJO'
	},
	{
		id: 43,
		description: 'BERÓN DE ASTRADA'
	},
	{
		id: 44,
		description: 'BIEDMA'
	},
	{
		id: 45,
		description: 'BOLÍVAR'
	},
	{
		id: 46,
		description: 'BRAGADO'
	},
	{
		id: 47,
		description: 'BRANDSEN'
	},
	{
		id: 48,
		description: 'BURRUYACÚ'
	},
	{
		id: 49,
		description: 'CACHI'
	},
	{
		id: 50,
		description: 'CAFAYATE'
	},
	{
		id: 51,
		description: 'CAINGUÁS'
	},
	{
		id: 52,
		description: 'CALAMUCHITA'
	},
	{
		id: 53,
		description: 'CALEU CALEU'
	},
	{
		id: 54,
		description: 'CALINGASTA'
	},
	{
		id: 55,
		description: 'CAMPANA'
	},
	{
		id: 56,
		description: 'CANDELARIA'
	},
	{
		id: 57,
		description: 'CAÑUELAS'
	},
	{
		id: 58,
		description: 'CAPAYÁN'
	},
	{
		id: 59,
		description: 'CAPITAL'
	},
	{
		id: 60,
		description: 'CAPITÁN SARMIENTO'
	},
	{
		id: 61,
		description: 'CARLOS CASARES'
	},
	{
		id: 62,
		description: 'CARLOS TEJEDOR'
	},
	{
		id: 63,
		description: 'CARMEN DE ARECO'
	},
	{
		id: 64,
		description: 'CASEROS'
	},
	{
		id: 65,
		description: 'CASTELLANOS'
	},
	{
		id: 66,
		description: 'CASTELLI'
	},
	{
		id: 67,
		description: 'CASTRO BARROS'
	},
	{
		id: 68,
		description: 'CATÁN LIL'
	},
	{
		id: 69,
		description: 'CATRILÓ'
	},
	{
		id: 70,
		description: 'CAUCETE'
	},
	{
		id: 71,
		description: 'CERRILLOS'
	},
	{
		id: 72,
		description: 'CHACABUCO'
	},
	{
		id: 73,
		description: 'CHALILEO'
	},
	{
		id: 74,
		description: 'CHAMICAL'
	},
	{
		id: 75,
		description: 'CHAPALEUFÚ'
	},
	{
		id: 76,
		description: 'CHASCOMÚS'
	},
	{
		id: 77,
		description: 'CHICAL CO'
	},
	{
		id: 78,
		description: 'CHICLIGASTA'
	},
	{
		id: 79,
		description: 'CHICOANA'
	},
	{
		id: 80,
		description: 'CHILECITO'
	},
	{
		id: 81,
		description: 'CHIMBAS'
	},
	{
		id: 82,
		description: 'CHIVILCOY'
	},
	{
		id: 83,
		description: 'CHOS MALAL'
	},
	{
		id: 84,
		description: 'CHOYA'
	},
	{
		id: 448,
		description: 'CIUDAD AUTÓNOMA DE BUENOS AIRES (CABA)'
	},
	{
		id: 85,
		description: 'COCHINOCA'
	},
	{
		id: 86,
		description: 'COLLÓN CURÁ'
	},
	{
		id: 87,
		description: 'COLÓN'
	},
	{
		id: 88,
		description: 'COMANDANTE FERNÁNDEZ'
	},
	{
		id: 89,
		description: 'COMUNA 1'
	},
	{
		id: 90,
		description: 'COMUNA 10'
	},
	{
		id: 91,
		description: 'COMUNA 11'
	},
	{
		id: 92,
		description: 'COMUNA 12'
	},
	{
		id: 93,
		description: 'COMUNA 13'
	},
	{
		id: 94,
		description: 'COMUNA 14'
	},
	{
		id: 95,
		description: 'COMUNA 15'
	},
	{
		id: 96,
		description: 'COMUNA 2'
	},
	{
		id: 97,
		description: 'COMUNA 3'
	},
	{
		id: 98,
		description: 'COMUNA 4'
	},
	{
		id: 99,
		description: 'COMUNA 5'
	},
	{
		id: 100,
		description: 'COMUNA 6'
	},
	{
		id: 101,
		description: 'COMUNA 7'
	},
	{
		id: 102,
		description: 'COMUNA 8'
	},
	{
		id: 103,
		description: 'COMUNA 9'
	},
	{
		id: 104,
		description: 'CONCEPCIÓN'
	},
	{
		id: 105,
		description: 'CONCORDIA'
	},
	{
		id: 106,
		description: 'CONESA'
	},
	{
		id: 107,
		description: 'CONFLUENCIA'
	},
	{
		id: 108,
		description: 'CONHELO'
	},
	{
		id: 109,
		description: 'CONSTITUCIÓN'
	},
	{
		id: 110,
		description: 'COPO'
	},
	{
		id: 111,
		description: 'CORONEL DE MARINA LEONARDO ROSALES'
	},
	{
		id: 112,
		description: 'CORONEL DORREGO'
	},
	{
		id: 113,
		description: 'CORONEL PRINGLES'
	},
	{
		id: 114,
		description: 'CORONEL SUÁREZ'
	},
	{
		id: 115,
		description: 'CORPEN AIKE'
	},
	{
		id: 116,
		description: 'CRUZ ALTA'
	},
	{
		id: 117,
		description: 'CRUZ DEL EJE'
	},
	{
		id: 118,
		description: 'CURACÓ'
	},
	{
		id: 119,
		description: 'CURUZÚ CUATIÁ'
	},
	{
		id: 120,
		description: 'CUSHAMEN'
	},
	{
		id: 121,
		description: 'DAIREAUX'
	},
	{
		id: 122,
		description: 'DESEADO'
	},
	{
		id: 123,
		description: 'DIAMANTE'
	},
	{
		id: 124,
		description: 'DOLORES'
	},
	{
		id: 125,
		description: 'DR. MANUEL BELGRANO'
	},
	{
		id: 126,
		description: 'EL ALTO'
	},
	{
		id: 127,
		description: 'EL CARMEN'
	},
	{
		id: 128,
		description: 'EL CUY'
	},
	{
		id: 129,
		description: 'ELDORADO'
	},
	{
		id: 130,
		description: 'EMPEDRADO'
	},
	{
		id: 131,
		description: 'ENSENADA'
	},
	{
		id: 132,
		description: 'ESCALANTE'
	},
	{
		id: 133,
		description: 'ESCOBAR'
	},
	{
		id: 134,
		description: 'ESQUINA'
	},
	{
		id: 135,
		description: 'ESTEBAN ECHEVERRÍA'
	},
	{
		id: 136,
		description: 'EXALTACIÓN DE LA CRUZ'
	},
	{
		id: 137,
		description: 'EZEIZA'
	},
	{
		id: 138,
		description: 'FAMAILLÁ'
	},
	{
		id: 139,
		description: 'FAMATINA'
	},
	{
		id: 140,
		description: 'FEDERACIÓN'
	},
	{
		id: 141,
		description: 'FEDERAL'
	},
	{
		id: 142,
		description: 'FELICIANO'
	},
	{
		id: 143,
		description: 'FIGUEROA'
	},
	{
		id: 144,
		description: 'FLORENCIO VARELA'
	},
	{
		id: 145,
		description: 'FLORENTINO AMEGHINO'
	},
	{
		id: 146,
		description: 'FORMOSA'
	},
	{
		id: 147,
		description: 'FRAY JUSTO SANTA MARÍA DE ORO'
	},
	{
		id: 148,
		description: 'FRAY MAMERTO ESQUIÚ'
	},
	{
		id: 149,
		description: 'FUTALEUFÚ'
	},
	{
		id: 150,
		description: 'GAIMAN'
	},
	{
		id: 151,
		description: 'GARAY'
	},
	{
		id: 152,
		description: 'GASTRE'
	},
	{
		id: 153,
		description: 'GENERAL ALVARADO'
	},
	{
		id: 154,
		description: 'GENERAL ALVEAR'
	},
	{
		id: 155,
		description: 'GENERAL ARENALES'
	},
	{
		id: 156,
		description: 'GENERAL BELGRANO'
	},
	{
		id: 157,
		description: 'GENERAL DONOVAN'
	},
	{
		id: 158,
		description: 'GENERAL FELIPE VARELA'
	},
	{
		id: 159,
		description: 'GENERAL GÜEMES'
	},
	{
		id: 160,
		description: 'GENERAL GUIDO'
	},
	{
		id: 161,
		description: 'GENERAL JOSÉ DE SAN MARTÍN'
	},
	{
		id: 162,
		description: 'GENERAL JUAN FACUNDO QUIROGA'
	},
	{
		id: 163,
		description: 'GENERAL JUAN MADARIAGA'
	},
	{
		id: 164,
		description: 'GENERAL LA MADRID'
	},
	{
		id: 165,
		description: 'GENERAL LAMADRID'
	},
	{
		id: 166,
		description: 'GENERAL LAS HERAS'
	},
	{
		id: 167,
		description: 'GENERAL LAVALLE'
	},
	{
		id: 168,
		description: 'GENERAL LÓPEZ'
	},
	{
		id: 169,
		description: 'GENERAL MANUEL BELGRANO'
	},
	{
		id: 170,
		description: 'GENERAL OBLIGADO'
	},
	{
		id: 171,
		description: 'GENERAL ORTIZ DE OCAMPO'
	},
	{
		id: 172,
		description: 'GENERAL PAZ'
	},
	{
		id: 173,
		description: 'GENERAL PEDERNERA'
	},
	{
		id: 174,
		description: 'GENERAL PINTO'
	},
	{
		id: 175,
		description: 'GENERAL PUEYRREDÓN'
	},
	{
		id: 176,
		description: 'GENERAL ROCA'
	},
	{
		id: 177,
		description: 'GENERAL RODRÍGUEZ'
	},
	{
		id: 178,
		description: 'GENERAL SAN MARTÍN'
	},
	{
		id: 179,
		description: 'GENERAL TABOADA'
	},
	{
		id: 180,
		description: 'GENERAL VIAMONTE'
	},
	{
		id: 181,
		description: 'GENERAL VILLEGAS'
	},
	{
		id: 182,
		description: 'GOBERNADOR DUPUY'
	},
	{
		id: 183,
		description: 'GODOY CRUZ'
	},
	{
		id: 184,
		description: 'GOYA'
	},
	{
		id: 185,
		description: 'GRANEROS'
	},
	{
		id: 186,
		description: 'GUACHIPAS'
	},
	{
		id: 187,
		description: 'GUALEGUAY'
	},
	{
		id: 188,
		description: 'GUALEGUAYCHÚ'
	},
	{
		id: 189,
		description: 'GUAMINÍ'
	},
	{
		id: 190,
		description: 'GUARANÍ'
	},
	{
		id: 191,
		description: 'GUASAYÁN'
	},
	{
		id: 192,
		description: 'GUATRACHÉ'
	},
	{
		id: 193,
		description: 'GUAYMALLÉN'
	},
	{
		id: 194,
		description: 'GÜER AIKE'
	},
	{
		id: 195,
		description: 'HIPÓLITO YRIGOYEN'
	},
	{
		id: 196,
		description: 'HUCAL'
	},
	{
		id: 197,
		description: 'HUILICHES'
	},
	{
		id: 198,
		description: 'HUMAHUACA'
	},
	{
		id: 199,
		description: 'HURLINGHAM'
	},
	{
		id: 200,
		description: 'IGLESIA'
	},
	{
		id: 201,
		description: 'IGUAZÚ'
	},
	{
		id: 202,
		description: 'INDEPENDENCIA'
	},
	{
		id: 203,
		description: 'IRIONDO'
	},
	{
		id: 204,
		description: 'IRUYA'
	},
	{
		id: 205,
		description: 'ISCHILÍN'
	},
	{
		id: 206,
		description: 'ISLAS DEL ATLÁNTICO SUR'
	},
	{
		id: 207,
		description: 'ISLAS DEL IBICUY'
	},
	{
		id: 208,
		description: 'ITATÍ'
	},
	{
		id: 209,
		description: 'ITUZAINGÓ'
	},
	{
		id: 210,
		description: 'JÁCHAL'
	},
	{
		id: 211,
		description: 'JIMÉNEZ'
	},
	{
		id: 212,
		description: 'JOSÉ C. PAZ'
	},
	{
		id: 213,
		description: 'JUAN BAUTISTA ALBERDI'
	},
	{
		id: 214,
		description: 'JUAN FELIPE IBARRA'
	},
	{
		id: 215,
		description: 'JUAN MARTÍN DE PUEYRREDÓN'
	},
	{
		id: 216,
		description: 'JUÁREZ CELMAN'
	},
	{
		id: 217,
		description: 'JUNÍN'
	},
	{
		id: 218,
		description: 'LA CALDERA'
	},
	{
		id: 219,
		description: 'LA CANDELARIA'
	},
	{
		id: 220,
		description: 'LA CAPITAL'
	},
	{
		id: 221,
		description: 'LA COCHA'
	},
	{
		id: 222,
		description: 'LA COSTA'
	},
	{
		id: 223,
		description: 'LA MATANZA'
	},
	{
		id: 224,
		description: 'LA PAZ'
	},
	{
		id: 225,
		description: 'LA PLATA'
	},
	{
		id: 226,
		description: 'LA POMA'
	},
	{
		id: 227,
		description: 'LA VIÑA'
	},
	{
		id: 228,
		description: 'LÁCAR'
	},
	{
		id: 229,
		description: 'LAGO ARGENTINO'
	},
	{
		id: 230,
		description: 'LAGO BUENOS AIRES'
	},
	{
		id: 231,
		description: 'LAISHI'
	},
	{
		id: 232,
		description: 'LANGUIÑEO'
	},
	{
		id: 233,
		description: 'LANÚS'
	},
	{
		id: 234,
		description: 'LAPRIDA'
	},
	{
		id: 235,
		description: 'LAS COLONIAS'
	},
	{
		id: 236,
		description: 'LAS FLORES'
	},
	{
		id: 237,
		description: 'LAS HERAS'
	},
	{
		id: 238,
		description: 'LAVALLE'
	},
	{
		id: 239,
		description: 'LEALES'
	},
	{
		id: 240,
		description: 'LEANDRO N. ALEM'
	},
	{
		id: 241,
		description: 'LEDESMA'
	},
	{
		id: 242,
		description: 'LEZAMA'
	},
	{
		id: 243,
		description: 'LIBERTAD'
	},
	{
		id: 244,
		description: 'LIBERTADOR GENERAL SAN MARTÍN'
	},
	{
		id: 245,
		description: 'LIHUEL CALEL'
	},
	{
		id: 246,
		description: 'LIMAY MAHUIDA'
	},
	{
		id: 247,
		description: 'LINCOLN'
	},
	{
		id: 248,
		description: 'LOBERÍA'
	},
	{
		id: 249,
		description: 'LOBOS'
	},
	{
		id: 250,
		description: 'LOMAS DE ZAMORA'
	},
	{
		id: 251,
		description: 'LONCOPUÉ'
	},
	{
		id: 252,
		description: 'LORETO'
	},
	{
		id: 253,
		description: 'LOS ANDES'
	},
	{
		id: 254,
		description: 'LOS LAGOS'
	},
	{
		id: 255,
		description: 'LOVENTUÉ'
	},
	{
		id: 256,
		description: 'LUJÁN'
	},
	{
		id: 257,
		description: 'LUJÁN DE CUYO'
	},
	{
		id: 258,
		description: 'LULES'
	},
	{
		id: 259,
		description: 'MAGALLANES'
	},
	{
		id: 260,
		description: 'MAGDALENA'
	},
	{
		id: 261,
		description: 'MAIPÚ'
	},
	{
		id: 262,
		description: 'MALARGÜE'
	},
	{
		id: 263,
		description: 'MALVINAS ARGENTINAS'
	},
	{
		id: 264,
		description: 'MAR CHIQUITA'
	},
	{
		id: 265,
		description: 'MARACÓ'
	},
	{
		id: 266,
		description: 'MARCOS JUÁREZ'
	},
	{
		id: 267,
		description: 'MARCOS PAZ'
	},
	{
		id: 268,
		description: 'MÁRTIRES'
	},
	{
		id: 269,
		description: 'MATACOS'
	},
	{
		id: 270,
		description: 'MAYOR LUIS J. FONTANA'
	},
	{
		id: 271,
		description: 'MBURUCUYÁ'
	},
	{
		id: 272,
		description: 'MERCEDES'
	},
	{
		id: 273,
		description: 'MERLO'
	},
	{
		id: 274,
		description: 'METÁN'
	},
	{
		id: 275,
		description: 'MINAS'
	},
	{
		id: 276,
		description: 'MITRE'
	},
	{
		id: 277,
		description: 'MOLINOS'
	},
	{
		id: 278,
		description: 'MONTE'
	},
	{
		id: 279,
		description: 'MONTE CASEROS'
	},
	{
		id: 280,
		description: 'MONTE HERMOSO'
	},
	{
		id: 281,
		description: 'MONTECARLO'
	},
	{
		id: 282,
		description: 'MONTEROS'
	},
	{
		id: 283,
		description: 'MORENO'
	},
	{
		id: 284,
		description: 'MORÓN'
	},
	{
		id: 285,
		description: 'NAVARRO'
	},
	{
		id: 286,
		description: 'NECOCHEA'
	},
	{
		id: 287,
		description: 'NOGOYÁ'
	},
	{
		id: 288,
		description: 'ÑORQUÍN'
	},
	{
		id: 289,
		description: 'ÑORQUINCO'
	},
	{
		id: 290,
		description: "O'HIGGINS"
	},
	{
		id: 291,
		description: 'OBERÁ'
	},
	{
		id: 292,
		description: 'OJO DE AGUA'
	},
	{
		id: 293,
		description: 'OLAVARRÍA'
	},
	{
		id: 294,
		description: 'ORÁN'
	},
	{
		id: 295,
		description: 'PACLÍN'
	},
	{
		id: 296,
		description: 'PALPALÁ'
	},
	{
		id: 297,
		description: 'PARANÁ'
	},
	{
		id: 298,
		description: 'PASO DE INDIOS'
	},
	{
		id: 299,
		description: 'PASO DE LOS LIBRES'
	},
	{
		id: 300,
		description: 'PATAGONES'
	},
	{
		id: 301,
		description: 'PATIÑO'
	},
	{
		id: 302,
		description: 'PEHUAJÓ'
	},
	{
		id: 303,
		description: 'PEHUENCHES'
	},
	{
		id: 304,
		description: 'PELLEGRINI'
	},
	{
		id: 305,
		description: 'PERGAMINO'
	},
	{
		id: 306,
		description: 'PICHI MAHUIDA'
	},
	{
		id: 307,
		description: 'PICÚN LEUFÚ'
	},
	{
		id: 308,
		description: 'PICUNCHES'
	},
	{
		id: 309,
		description: 'PILA'
	},
	{
		id: 310,
		description: 'PILAGÁS'
	},
	{
		id: 311,
		description: 'PILAR'
	},
	{
		id: 312,
		description: 'PILCANIYEU'
	},
	{
		id: 313,
		description: 'PILCOMAYO'
	},
	{
		id: 314,
		description: 'PINAMAR'
	},
	{
		id: 315,
		description: 'PIRANÉ'
	},
	{
		id: 316,
		description: 'POCHO'
	},
	{
		id: 317,
		description: 'POCITO'
	},
	{
		id: 318,
		description: 'POMÁN'
	},
	{
		id: 319,
		description: 'PRESIDENCIA DE LA PLAZA'
	},
	{
		id: 320,
		description: 'PRESIDENTE PERÓN'
	},
	{
		id: 321,
		description: 'PRESIDENTE ROQUE SÁENZ PEÑA'
	},
	{
		id: 322,
		description: 'PUÁN'
	},
	{
		id: 323,
		description: 'PUELÉN'
	},
	{
		id: 324,
		description: 'PUNILLA'
	},
	{
		id: 325,
		description: 'PUNTA INDIO'
	},
	{
		id: 326,
		description: 'QUEBRACHOS'
	},
	{
		id: 327,
		description: 'QUEMÚ QUEMÚ'
	},
	{
		id: 328,
		description: 'QUILMES'
	},
	{
		id: 329,
		description: 'QUITILIPI'
	},
	{
		id: 330,
		description: 'RAMALLO'
	},
	{
		id: 331,
		description: 'RAMÓN LISTA'
	},
	{
		id: 332,
		description: 'RANCUL'
	},
	{
		id: 333,
		description: 'RAUCH'
	},
	{
		id: 334,
		description: 'RAWSON'
	},
	{
		id: 335,
		description: 'REALICÓ'
	},
	{
		id: 336,
		description: 'RINCONADA'
	},
	{
		id: 337,
		description: 'RÍO CHICO'
	},
	{
		id: 338,
		description: 'RÍO CUARTO'
	},
	{
		id: 339,
		description: 'RÍO GRANDE'
	},
	{
		id: 340,
		description: 'RÍO HONDO'
	},
	{
		id: 341,
		description: 'RÍO PRIMERO'
	},
	{
		id: 342,
		description: 'RÍO SECO'
	},
	{
		id: 343,
		description: 'RÍO SEGUNDO'
	},
	{
		id: 344,
		description: 'RÍO SENGUER'
	},
	{
		id: 345,
		description: 'RIVADAVIA'
	},
	{
		id: 346,
		description: 'ROBLES'
	},
	{
		id: 347,
		description: 'ROJAS'
	},
	{
		id: 348,
		description: 'ROQUE PÉREZ'
	},
	{
		id: 349,
		description: 'ROSARIO'
	},
	{
		id: 350,
		description: 'ROSARIO DE LA FRONTERA'
	},
	{
		id: 351,
		description: 'ROSARIO DE LERMA'
	},
	{
		id: 352,
		description: 'ROSARIO VERA PEÑALOZA'
	},
	{
		id: 353,
		description: 'SAAVEDRA'
	},
	{
		id: 354,
		description: 'SALADAS'
	},
	{
		id: 355,
		description: 'SALADILLO'
	},
	{
		id: 356,
		description: 'SALAVINA'
	},
	{
		id: 357,
		description: 'SALLIQUELÓ'
	},
	{
		id: 358,
		description: 'SALTO'
	},
	{
		id: 359,
		description: 'SAN ALBERTO'
	},
	{
		id: 360,
		description: 'SAN ANDRÉS DE GILES'
	},
	{
		id: 361,
		description: 'SAN ANTONIO'
	},
	{
		id: 362,
		description: 'SAN ANTONIO DE ARECO'
	},
	{
		id: 363,
		description: 'SAN BLAS DE LOS SAUCES'
	},
	{
		id: 364,
		description: 'SAN CARLOS'
	},
	{
		id: 365,
		description: 'SAN CAYETANO'
	},
	{
		id: 366,
		description: 'SAN COSME'
	},
	{
		id: 367,
		description: 'SAN CRISTÓBAL'
	},
	{
		id: 368,
		description: 'SAN FERNANDO'
	},
	{
		id: 369,
		description: 'SAN IGNACIO'
	},
	{
		id: 370,
		description: 'SAN ISIDRO'
	},
	{
		id: 371,
		description: 'SAN JAVIER'
	},
	{
		id: 372,
		description: 'SAN JERÓNIMO'
	},
	{
		id: 373,
		description: 'SAN JUSTO'
	},
	{
		id: 374,
		description: 'SAN LORENZO'
	},
	{
		id: 375,
		description: 'SAN LUIS DEL PALMAR'
	},
	{
		id: 376,
		description: 'SAN MARTÍN'
	},
	{
		id: 377,
		description: 'SAN MIGUEL'
	},
	{
		id: 378,
		description: 'SAN NICOLÁS'
	},
	{
		id: 379,
		description: 'SAN PEDRO'
	},
	{
		id: 380,
		description: 'SAN RAFAEL'
	},
	{
		id: 381,
		description: 'SAN ROQUE'
	},
	{
		id: 382,
		description: 'SAN SALVADOR'
	},
	{
		id: 383,
		description: 'SAN VICENTE'
	},
	{
		id: 384,
		description: 'SANAGASTA'
	},
	{
		id: 385,
		description: 'SANTA BÁRBARA'
	},
	{
		id: 386,
		description: 'SANTA CATALINA'
	},
	{
		id: 387,
		description: 'SANTA LUCÍA'
	},
	{
		id: 388,
		description: 'SANTA MARÍA'
	},
	{
		id: 389,
		description: 'SANTA ROSA'
	},
	{
		id: 390,
		description: 'SANTA VICTORIA'
	},
	{
		id: 391,
		description: 'SANTO TOMÉ'
	},
	{
		id: 392,
		description: 'SARGENTO CABRAL'
	},
	{
		id: 393,
		description: 'SARMIENTO'
	},
	{
		id: 394,
		description: 'SAUCE'
	},
	{
		id: 395,
		description: 'SILÍPICA'
	},
	{
		id: 396,
		description: 'SIMOCA'
	},
	{
		id: 397,
		description: 'SOBREMONTE'
	},
	{
		id: 398,
		description: 'SUIPACHA'
	},
	{
		id: 399,
		description: 'SUSQUES'
	},
	{
		id: 400,
		description: 'TAFÍ DEL VALLE'
	},
	{
		id: 401,
		description: 'TAFÍ VIEJO'
	},
	{
		id: 402,
		description: 'TALA'
	},
	{
		id: 403,
		description: 'TANDIL'
	},
	{
		id: 404,
		description: 'TAPALQUÉ'
	},
	{
		id: 405,
		description: 'TAPENAGÁ'
	},
	{
		id: 406,
		description: 'TEHUELCHES'
	},
	{
		id: 407,
		description: 'TELSEN'
	},
	{
		id: 408,
		description: 'TERCERO ARRIBA'
	},
	{
		id: 409,
		description: 'TIGRE'
	},
	{
		id: 410,
		description: 'TILCARA'
	},
	{
		id: 411,
		description: 'TINOGASTA'
	},
	{
		id: 412,
		description: 'TOAY'
	},
	{
		id: 413,
		description: 'TOLHUIN'
	},
	{
		id: 414,
		description: 'TORDILLO'
	},
	{
		id: 415,
		description: 'TORNQUIST'
	},
	{
		id: 416,
		description: 'TOTORAL'
	},
	{
		id: 417,
		description: 'TRANCAS'
	},
	{
		id: 418,
		description: 'TRENEL'
	},
	{
		id: 419,
		description: 'TRENQUE LAUQUEN'
	},
	{
		id: 420,
		description: 'TRES ARROYOS'
	},
	{
		id: 421,
		description: 'TRES DE FEBRERO'
	},
	{
		id: 422,
		description: 'TRES LOMAS'
	},
	{
		id: 423,
		description: 'TULUMBA'
	},
	{
		id: 424,
		description: 'TUMBAYA'
	},
	{
		id: 425,
		description: 'TUNUYÁN'
	},
	{
		id: 426,
		description: 'TUPUNGATO'
	},
	{
		id: 427,
		description: 'ULLUM'
	},
	{
		id: 428,
		description: 'UNIÓN'
	},
	{
		id: 429,
		description: 'URUGUAY'
	},
	{
		id: 430,
		description: 'USHUAIA'
	},
	{
		id: 431,
		description: 'UTRACÁN'
	},
	{
		id: 432,
		description: 'VALCHETA'
	},
	{
		id: 433,
		description: 'VALLE FÉRTIL'
	},
	{
		id: 434,
		description: 'VALLE GRANDE'
	},
	{
		id: 435,
		description: 'VALLE VIEJO'
	},
	{
		id: 436,
		description: 'VERA'
	},
	{
		id: 437,
		description: 'VICENTE LÓPEZ'
	},
	{
		id: 438,
		description: 'VICTORIA'
	},
	{
		id: 439,
		description: 'VILLA GESELL'
	},
	{
		id: 440,
		description: 'VILLAGUAY'
	},
	{
		id: 441,
		description: 'VILLARINO'
	},
	{
		id: 442,
		description: 'VINCHINA'
	},
	{
		id: 443,
		description: 'YAVI'
	},
	{
		id: 444,
		description: 'YERBA BUENA'
	},
	{
		id: 445,
		description: 'ZAPALA'
	},
	{
		id: 446,
		description: 'ZÁRATE'
	},
	{
		id: 447,
		description: 'ZONDA'
	}
];
